<template>
  <section id="s513-animated-counter" class="member_counter my-5">
    <b-col lg="12" class=" bg-dark">
      <b-container >

        <slot></slot>

      </b-container>
    </b-col>
  </section>


</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'S513',
  methods: {
    findNumber(text) {
      var r = /\d+/;
      const number = text.match(r)[0]
      return number == null ? 0 : number
    },
    counterAnimation(el, count) {
      count = this.findNumber(count)
      var divisor = count;
      var speed = Math.round(count / divisor);
      var start = 0;
      var interval = setInterval(function () {
        if (start >= count) {
          clearInterval(interval);
        } else {
          start++;
          el.textContent = start;
        }
      }, speed);
    },
    onVisible(element, callback) {
      new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            callback(element);
            observer.disconnect();
          }
        });
      }).observe(element);
    },
  },
  computed: {
    ...mapGetters({
      loading: "Loading/loadingStatus"
    })
  },
  mounted() {

  },
  watch: {
    loading: {
      handler: function (newValue, oldValue) {

        const counterAbleElements = document.querySelectorAll('.counter');
        this.onVisible(document.querySelector("#s513-animated-counter"), () => {
          counterAbleElements.forEach(el => {
            const count = el.getAttribute('data-count');
            this.counterAnimation(el, count);
          });
        });

      },
      deep: true
    },
  }
}
</script>

<style >
#s513-animated-counter img{
  object-fit: cover;
  height: 250px;
}
</style>